<template>
  <v-btn color="primary"
          v-bind="$attrs"
          v-on="$listeners"
          :loading="loading"
          :class="loading?'lock':''"
          @click="loader = 'loading'">
    <slot></slot>
  </v-btn>
</template>
<script>
import BaseBtn from './BaseBtn'
export default {
  name: 'btn-info',
  extends: BaseBtn
}
</script>
<style lang="stylus" scoped></style>
